module.exports = __webpack_public_path__ + "img/logo_small.9ed12488.svg";